import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export interface Me {
  user_id: string;
  email: string;
  groups: string[];
}

export function useMe() {
  return useQuery<Me>({
    queryKey: ['me'],
    queryFn: async () => (await api.get('/crm/me')).data,
  });
}

export const isStaff = (me?: Me) =>
  Boolean(me?.groups.some((g) => g === 'admin' || g === 'agent'));
